<style>
  .container-gauge{
    height: 300px;
  }
</style>
<template>
<div id="device-stadistics-view">
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-button :to="`/airFlow/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-col w-full mb-base">
      <vs-tabs>
            <vs-tab :label="$t('Labels.State')" icon-pack="feather" icon="icon-list" @click="getResponse()">
              <vx-card
                  title="Últimas Lecturas">
                      <div style="width: 100%">
                        <a v-if="urlDownload.length > 0" class="btn-primary float-left" :href="urlDownload" download="LogEstado.csv"><feather-icon icon="DownloadCloudIcon" /></a>
                        <select class="vs-vs-inputx vs-input--input mb-3" v-model="log_limit" style="float: right; width: 90px;" @change="getResponse()">
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>

                    <vs-table v-if="response" ref="table" :data="response">
                    <template slot-scope="{data}">
                      <tbody>
                        <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="indextr" v-for="(item, indextr) in data" >
                          <listItem
                            :value="item.createdAt"
                            :description="$t('Labels.Date')"
                            img="fecha"
                          ></listItem>
                          <listItem
                            :value="item.createdAt"
                            :description="$t('Labels.LastUpdated')"
                            img="clock"
                            :relativeTime="true"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.flow).toFixed(2)"
                            :description="$t('Labels.Flow')"
                            img="flow"
                            unit="ft3/h"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.temperature).toFixed(2)"
                            :description="$t('Labels.Temperature')"
                            img="temperature"
                            unit="°C"
                          ></listItem>
                          <listItem
                            :value="((parseFloat(item.temperature) * 9 / 5) + 32).toFixed(2)"
                            :description="$t('Labels.Temperature')"
                            img="temperature"
                            unit="°F"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.pressure).toFixed(2)"
                            :description="$t('Labels.Pressure')"
                            img="pressure"
                            unit="Psi"
                          ></listItem>
                        </tr>
                      </tbody>
                    </template>
                  </vs-table>

              </vx-card>
            </vs-tab>
            <vs-tab :label="$t('Labels.InstantValues')" icon-pack="feather" icon="icon-activity" @click="getInfoGauges()">
              <vs-switch v-model="activeRefresh">
                <span slot="on">{{$t('Labels.Refresh')}}</span>
                <span slot="off">No {{$t('Labels.Refresh')}}</span>
              </vs-switch>

              <div class="flex mt-12" v-if="showGauges">
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.flow.min"
                      :max="limits.flow.max"
                      :alertMin="gauges.min_flow"
                      :alertMax="gauges.max_flow"
                      :title="$t('Labels.Flow')"
                      :value="gauges.flow"
                      unit="ft3/h"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                    <vx-card class="container-gauge">
                    <gauge
                      :min="limits.temperature.min"
                      :max="limits.temperature.max"
                      :alertMin="gauges.min_temperature"
                      :alertMax="gauges.max_temperature"
                      :title="$t('Labels.Temperature')"
                      :value="gauges.temperature"
                      unit="°C"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                    <vx-card class="container-gauge">
                    <gauge
                      :min="limits.pressure.min"
                      :max="limits.pressure.max"
                      :alertMin="gauges.min_pressure"
                      :alertMax="gauges.max_pressure"
                      :title="$t('Labels.Pressure')"
                      :value="gauges.pressure"
                      unit="Psi"
                    />
                  </vx-card>
                </div>
              </div>
            </vs-tab>
            <vs-tab :label="$t('Labels.Graphics')" icon-pack="feather" icon="icon-activity" @click="getCharts()">
              <div>{{$t('Labels.Last24Hours')}}</div>
              <div class="flex" v-if="showAvg24">
                <div class="flex-1 p-4">
                  <statistics
                    img="flow"
                    :value="parseFloat(avg24.avg_flow).toFixed(2)"
                    :min="parseFloat(avg24.min_flow).toFixed(2)"
                    :max="parseFloat(avg24.max_flow).toFixed(2)"
                    unit="ft3/h"
                    :title="$t('Labels.Flow')"
                  />
                </div>
                <div class="flex-1 p-4">
                  <statistics
                    img="temperature"
                    :value="parseFloat(avg24.avg_temperature).toFixed(2)"
                    :min="parseFloat(avg24.min_temperature).toFixed(2)"
                    :max="parseFloat(avg24.max_temperature).toFixed(2)"
                    unit="°C"
                    :title="$t('Labels.Temperature')"
                  />
                </div>
                <div class="flex-1 p-4">
                  <statistics
                    img="temperature"
                    :value="((parseFloat(avg24.avg_temperature) * 9 / 5) + 32).toFixed(2)"
                    :min="((parseFloat(avg24.min_temperature) * 9 / 5) + 32).toFixed(2)"
                    :max="((parseFloat(avg24.max_temperature) * 9 / 5) + 32).toFixed(2)"
                    unit="°F"
                    :title="$t('Labels.Temperature')"
                  />
                </div>
                <div class="flex-1 p-4">
                  <statistics
                    img="pressure"
                    :value="parseFloat(avg24.avg_pressure).toFixed(2)"
                    :min="parseFloat(avg24.min_pressure).toFixed(2)"
                    :max="parseFloat(avg24.max_pressure).toFixed(2)"
                    unit="Psi"
                    :title="$t('Labels.Pressure')"
                  />
                </div>
              </div>
              <div class="flex" v-if="showAvg24">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticFlow',0)">
                    <apexchart v-if="flow.loaded" type="bar" height="350" :options="flow.options" :series="flow.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticTemperature',0)">
                    <apexchart v-if="temp.loaded" type="bar" height="350" :options="temp.options" :series="temp.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticPressure',0)">
                    <apexchart v-if="pressure.loaded" type="bar" height="350" :options="pressure.options" :series="pressure.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div>{{$t('Labels.Today')}}</div>
              <div class="flex" v-if="showToday">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticFlow',1)">
                    <apexchart v-if="flowToday.loaded" type="line" height="350" :options="flowToday.options" :series="flowToday.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticTemperature',1)">
                    <apexchart v-if="tempToday.loaded" type="line" height="350" :options="tempToday.options" :series="tempToday.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticPressure',1)">
                    <apexchart v-if="pressureToday.loaded" type="line" height="350" :options="pressureToday.options" :series="pressureToday.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div>{{$t('Labels.LastWeek')}}</div>
              <div class="flex" v-if="showWeek">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticFlow',2)">
                    <apexchart v-if="flowWeek.loaded" type="line" height="350" :options="flowWeek.options" :series="flowWeek.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticTemperature',2)">
                    <apexchart v-if="tempWeek.loaded" type="line" height="350" :options="tempWeek.options" :series="tempWeek.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.StatisticPressure',2)">
                    <apexchart v-if="pressureWeek.loaded" type="line" height="350" :options="pressureWeek.options" :series="pressureWeek.data"></apexchart>
                  </vx-card>
                </div>
              </div>
            </vs-tab>
      </vs-tabs>
    </div>

  </div>

</div>

</template>

<script>

import apexchart from 'vue-apexcharts'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import statistics from '@/components/statistics/statistics.vue'
import gauge from '@/components/gauge/gauge.vue'
import { empty } from '@/helpers.js'

export default {
  components: {
    apexchart,
    listItem,
    statistics,
    gauge
  },
  data () {
    return {
      response: [],
      log_limit: '5',
      uuid: this.$route.params.uuid,
      flow: {
        data: [{ data: [], name: 'Flujo' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      temp: {
        data: [{ data: [], name: 'Temperatura' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}°C`
              }
            }
          }
        }
      },
      pressure: {
        data: [{ data: [], name: 'Presión' }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} psi`
              }
            }
          }
        }
      },
      flowWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      pressureWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempWeek: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      flowToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      pressureToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      urlDownload: '',
      avg24: {},
      gauges: [],
      limits: [],
      showGauges: false,
      showAvg24: false,
      showWeek: false,
      showToday: false,
      activeRefresh: false,
      doRefresh: {}
    }
  },
  methods: {
    async getResponse () {
      this.$vs.loading()

      this.showGauges = false
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false

      const params = {
        url: `modelo/airFlow/${this.uuid}/logs`,
        method: 'GET',
        params: {
          limit: this.log_limit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.$vs.loading.close()
        this.createCsv()
      })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getCharts () {
      this.showGauges = false
      this.getDayStatictics()
      this.getWeekStatistics()
      this.getTodayStatistics()
    },

    async getDayStatictics () {
      this.$vs.loading()

      const params = {
        url: `modelo/airFlow/${this.uuid}/stadistics_24`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.avg24 = response.data.data[0]
        if (response.data.data.length > 0) {
          this.flow.data[0].data.push(parseFloat(response.data.data[0].min_flow).toFixed(2))
          this.flow.data[0].data.push(parseFloat(response.data.data[0].avg_flow).toFixed(2))
          this.flow.data[0].data.push(parseFloat(response.data.data[0].max_flow).toFixed(2))

          this.temp.data[0].data.push(parseFloat(response.data.data[0].min_temperature).toFixed(2))
          this.temp.data[0].data.push(parseFloat(response.data.data[0].avg_temperature).toFixed(2))
          this.temp.data[0].data.push(parseFloat(response.data.data[0].max_temperature).toFixed(2))

          this.pressure.data[0].data.push(parseFloat(response.data.data[0].min_pressure).toFixed(2))
          this.pressure.data[0].data.push(parseFloat(response.data.data[0].avg_pressure).toFixed(2))
          this.pressure.data[0].data.push(parseFloat(response.data.data[0].max_pressure).toFixed(2))
        }
        this.flow.loaded = true
        this.temp.loaded = true
        this.pressure.loaded = true
        this.showAvg24 = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    async getWeekStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/airFlow/${this.uuid}/week`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.tempWeek.label = []
        this.flowWeek.label = []
        this.pressureWeek.label = []

        this.tempWeek.dataAvg = []
        this.tempWeek.dataMin = []
        this.tempWeek.dataMax = []

        this.flowWeek.dataAvg = []
        this.flowWeek.dataMin = []
        this.flowWeek.dataMax = []

        this.pressureWeek.dataAvg = []
        this.pressureWeek.dataMin = []
        this.pressureWeek.dataMax = []

        response.data.data.forEach(function (item) {
          api.tempWeek.labels.push(item.day.split(' ')[0])
          api.tempWeek.dataAvg.push(parseFloat(item.avg_temperature).toFixed(2))
          api.tempWeek.dataMin.push(parseFloat(item.min_temperature).toFixed(2))
          api.tempWeek.dataMax.push(parseFloat(item.max_temperature).toFixed(2))

          api.flowWeek.labels.push(item.day.split(' ')[0])
          api.flowWeek.dataAvg.push(parseFloat(item.avg_flow).toFixed(2))
          api.flowWeek.dataMin.push(parseFloat(item.min_flow).toFixed(2))
          api.flowWeek.dataMax.push(parseFloat(item.max_flow).toFixed(2))

          api.pressureWeek.labels.push(item.day.split(' ')[0])
          api.pressureWeek.dataAvg.push(parseFloat(item.avg_pressure).toFixed(2))
          api.pressureWeek.dataMin.push(parseFloat(item.min_pressure).toFixed(2))
          api.pressureWeek.dataMax.push(parseFloat(item.max_pressure).toFixed(2))
        })

        this.flowWeek.data = [
          {
            name: 'Mínimo',
            data: this.flowWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.flowWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.flowWeek.dataMax
          }
        ]
        this.tempWeek.data = [
          {
            name: 'Mínimo',
            data: this.tempWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.tempWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.tempWeek.dataMax
          }
        ]

        this.pressureWeek.data = [
          {
            name: 'Mínimo',
            data: this.pressureWeek.dataMin
          },
          {
            name: 'Promedio',
            data: this.pressureWeek.dataAvg
          },
          {
            name: 'Máximo',
            data: this.pressureWeek.dataMax
          }
        ]
        this.flowWeek.options = this.getOptions()
        this.flowWeek.options.tooltip = {
          y: {
            formatter (val) {
              return `${val} ft3/h`
            }
          }
        }
        this.flowWeek.options.xaxis.categories = this.flowWeek.labels

        this.tempWeek.options = this.getOptions()
        this.tempWeek.options.tooltip = {
          y: {
            formatter (val) {
              return `${val} °C`
            }
          }
        }
        this.tempWeek.options.xaxis.categories = this.tempWeek.labels

        this.pressureWeek.options = this.getOptions()
        this.pressureWeek.options.tooltip = {
          y: {
            formatter (val) {
              return `${val} Psi`
            }
          }
        }
        this.pressureWeek.options.xaxis.categories = this.pressureWeek.labels

        this.tempWeek.loaded = true
        this.flowWeek.loaded = true
        this.pressureWeek.loaded = true

        this.$vs.loading.close()
        this.showWeek = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    async getTodayStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/airFlow/${this.uuid}/today`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.tempToday.label = []
        this.flowToday.label = []
        this.pressureToday.label = []

        this.tempToday.dataAvg = []
        this.tempToday.dataMin = []
        this.tempToday.dataMax = []

        this.flowToday.dataAvg = []
        this.flowToday.dataMin = []
        this.flowToday.dataMax = []

        this.pressureToday.dataAvg = []
        this.pressureToday.dataMin = []
        this.pressureToday.dataMax = []

        response.data.data.forEach(function (item) {
          api.tempToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.tempToday.dataAvg.push(parseFloat(item.avg_temperature).toFixed(2))
          api.tempToday.dataMin.push(parseFloat(item.min_temperature).toFixed(2))
          api.tempToday.dataMax.push(parseFloat(item.max_temperature).toFixed(2))

          api.flowToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.flowToday.dataAvg.push(parseFloat(item.avg_flow).toFixed(2))
          api.flowToday.dataMin.push(parseFloat(item.min_flow).toFixed(2))
          api.flowToday.dataMax.push(parseFloat(item.max_flow).toFixed(2))

          api.pressureToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
          api.pressureToday.dataAvg.push(parseFloat(item.avg_pressure).toFixed(2))
          api.pressureToday.dataMin.push(parseFloat(item.min_pressure).toFixed(2))
          api.pressureToday.dataMax.push(parseFloat(item.max_pressure).toFixed(2))
        })

        this.flowToday.data = [
          {
            name: 'Mínimo',
            data: this.flowToday.dataMin
          },
          {
            name: 'Promedio',
            data: this.flowToday.dataAvg
          },
          {
            name: 'Máximo',
            data: this.flowToday.dataMax
          }
        ]
        this.tempToday.data = [
          {
            name: 'Mínimo',
            data: this.tempToday.dataMin
          },
          {
            name: 'Promedio',
            data: this.tempToday.dataAvg
          },
          {
            name: 'Máximo',
            data: this.tempToday.dataMax
          }
        ]

        this.pressureToday.data = [
          {
            name: 'Mínimo',
            data: this.pressureToday.dataMin
          },
          {
            name: 'Promedio',
            data: this.pressureToday.dataAvg
          },
          {
            name: 'Máximo',
            data: this.pressureToday.dataMax
          }
        ]

        this.flowToday.options = this.getOptions()
        this.flowToday.options.xaxis.categories = this.flowToday.labels
        this.flowToday.options.tooltip = {
          y: {
            formatter (val) {
              return `${val} ft3/h`
            }
          }
        }

        this.tempToday.options = this.getOptions()
        this.tempToday.options.xaxis.categories = this.tempToday.labels
        this.tempToday.options.tooltip = {
          y: {
            formatter (val) {
              return `${val} °C`
            }
          }
        }

        this.pressureToday.options = this.getOptions()
        this.pressureToday.options.xaxis.categories = this.pressureToday.labels
        this.pressureToday.options.tooltip = {
          y: {
            formatter (val) {
              return `${val} Psi`
            }
          }
        }

        this.tempToday.loaded = true
        this.flowToday.loaded = true
        this.pressureToday.loaded = true

        this.$vs.loading.close()
        this.showToday = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getOptions () {
      return {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val}°C`
            }
          }
        }
      }
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.LastSeen'))
      headers.push(this.$t('Labels.Temperature'))
      headers.push(this.$t('Labels.Flow'))
      headers.push(this.$t('Labels.Pressure'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.createdAt)
        row.push(this.relativeTimeConvert(item.createdAt))
        row.push(`${item.temperature}°C`)
        row.push(`${item.flow}ft3/h`)
        row.push(`${item.pressure}Pa`)
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    },
    async getInfoGauges () {
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      this.$vs.loading()
      const params = {
        url: `modelo/airflow/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.gauges = response.data.data
        this.limits = response.data.limits
        this.showGauges = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getResponse()
  },
  watch: {
    activeRefresh (val) {
      if (val) {
        const app = this
        let miliseconds = 0
        const units = {
          seconds: 1000,
          minutes: 60000,
          hours: 3600000
        }
        if (!empty(this.gauges.time) && !empty(this.gauges.time_unity)) { miliseconds = parseInt(this.gauges.time) * parseInt(units[this.gauges.time_unity]) } else { miliseconds = 11000 }

        this.doRefresh = setInterval(function () {
          app.getInfoGauges()
        }, miliseconds)
      } else {
        clearInterval(this.doRefresh)
      }
    }
  }

}
</script>
